/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import createLoadableComponent from 'js/lib/createLoadableComponent';

import { DEFAULT_PAGE_HEADER_HEIGHT } from 'bundles/composable-page-header/constants';
import { usePageHeaderHeight } from 'bundles/composable-page-header/contexts/PageHeaderHeightContext';
import { usePageHeaderOffset } from 'bundles/composable-page-header/contexts/PageHeaderOffsetContext';
import MegaMenuWrapper from 'bundles/page-header/components/desktop/mega-menu/MegaMenuWrapperLite';
import LazyLoadingHandler from 'bundles/page/components/shared/LazyLoadingHandler';

const LoadableMegaMenu = createLoadableComponent(
  () => import('bundles/page-header/components/optimized/MegaMenuContent'),
  LazyLoadingHandler
);

type Props = {
  // Render menu content on server for SEO reasons, used on logged-out homepage.
  renderMenuOnServer?: boolean;
};

const LegacyExploreMegaMenuGridItem = ({ renderMenuOnServer }: Props) => {
  const headerHeight = usePageHeaderHeight()?.height ?? DEFAULT_PAGE_HEADER_HEIGHT;
  const headerOffset = usePageHeaderOffset()?.scrollMovementOffset ?? 0;

  const setTopStyle = () => css`
    .rc-MegaMenuWrapper {
      .mega-menu-overlay--lazy-loading {
        top: ${headerHeight}px !important;
        height: calc(100vh - ${headerHeight - headerOffset}px) !important;
      }
    }
  `;

  return (
    <div className="rc-LegacyExploreMegaMenuGridItem" css={setTopStyle()}>
      <MegaMenuWrapper
        renderMenuOnServer={renderMenuOnServer}
        key="MegamenuWrapper"
        LoadableMegaMenu={LoadableMegaMenu}
      />
    </div>
  );
};

export default LegacyExploreMegaMenuGridItem;
